import { API, TeamAPI } from '@brg/api';
import { createAsyncThunk } from '@reduxjs/toolkit';

  export const fetchTeams = createAsyncThunk(
    'teams/fetchTeams',
    async (args: any, { getState }: {getState: any}) => {
        const { ownerId, lang } = args;
        // const { filter, paging } = getState().projects;

        const json = await API.Json(
              TeamAPI.GetOwned({
                ownerId: ownerId as string 
              })
          )
        return json
    }
  );

  export const updateTeam = createAsyncThunk(
    'teams/updateTeam',
    async (args: any, { getState }: {getState: any}) => {
        const { data, msg } = args;

        const json = await API.Json(
               TeamAPI.Update(data).then((r) => {
                if (r?.status === 200) {
                  msg.info('Успешно')
                }
              }).catch((err) => msg.error('Возникли проблемы'))
          )
        return json
    }
  );
import { API, TeamAPI } from '@brg/api';
import { createAsyncThunk } from '@reduxjs/toolkit';

  export const fetchTeams = createAsyncThunk(
    'teams/fetchTeams',
    async (args: any, { getState }: {getState: any}) => {
        const { ownerId, lang } = args;
        // const { filter, paging } = getState().projects;

        const json = await API.Json(
              TeamAPI.GetOwned({
                ownerId: ownerId as string 
              })
          )
        return json
    }
  );

  export const updateTeam = createAsyncThunk(
    'teams/updateTeam',
    async (args: any, { getState }: {getState: any}) => {
        const { data, msg } = args;

        const json = await API.Json(
               TeamAPI.Update(data).then((r) => {
                if (r?.status === 200) {
                  msg.info('Успешно')
                }
              }).catch((err) => msg.error('Возникли проблемы'))
          )
        return json
    }
  );
